import React from 'react';
import { Tooltip } from '@fluentui/react-components';

interface WithTooltipProps {
  tooltip: string;
	showTooltip: boolean;
	children?: React.ReactElement | null;
}

export function WithTooltip(props: WithTooltipProps) {
	if (!props.showTooltip) {
		return props?.children;
	}

	return (
		<Tooltip content={props.tooltip} relationship="label">
			{props?.children}
		</Tooltip>
	);
}